import { RouteConfig } from 'vue-router';
const BASE_PATH = 'views/dataManagement';
const popularScience: Array<RouteConfig> = [
    {
        path: 'data-manage/system-manage',
        name: 'systemManage',
        redirect: { name: 'organizationManage' },
        meta: {
            menuMatch: 'organizationManage',
        },
        component: () => import(`@/${BASE_PATH}/Main.vue`),
        children: [
            {
                path: 'organization',
                name: 'organizationManage',
                component: () => import(`@/${BASE_PATH}/systemManage/SystemManage.vue`),
                meta: {
                    index: '9',
                },
            },
        ],
    },
];
export default popularScience;